<script>
    import { onMount } from 'svelte';

    import OpenLayers from '../components/maps/openlayers.svelte'
    import LabelSelection from '../project/label-selection.svelte'
    import OutputSettings from '../project/output-settings.svelte'
    import OutputSyntaticSettings from '../project/output-settings-syntatic.svelte'
    import RealDataList from '../project/real-data-list.svelte';
    import SyntaticDataList from '../project/syntatic-data-list.svelte';

    import Accordion, { Panel, Header, Content } from '@smui-extra/accordion';
    import Button, { Label, Icon as ButtonIcon } from '@smui/button';
    import Fab, { Icon } from '@smui/fab';
    import Badge from '@smui-extra/badge';
    import Chip, { Set, Text } from '@smui/chips';
    import {extractImageFromCanvas, copyCanvas, addEntitiesToExtent} from '../lib/image-from-canvas';
    import {saveSettings, loadSettings, removeSettings} from '../lib/local-storage';
    import IconButton from '@smui/icon-button';
    import { nanoid } from 'nanoid'
    import DataTable, { Head, Body, Row, Cell as TableCell } from '@smui/data-table';

    import BaseMapSelection from '../project/base-map-selection.svelte';
    

    import DropGeoJson from './drop-geo-json.svelte'

    import Switch from '@smui/switch';
    import Drawer, {
        AppContent,
        Title,
        Subtitle,
        Scrim,
    } from '@smui/drawer';
    import MenuSurface from '@smui/menu-surface';

    import Tab from '@smui/tab';
    import TabBar from '@smui/tab-bar';

    /*import JSZip from "jszip";
    import saveAs from 'save-as'*/
    import createZip from '../lib/download';

    import {getPredictionFromCanvas} from '../lib/ml';

    let surface;
    let drawerType = 'forground';
    let openExtends = false;
    let tabs = [
        {
            id: 'tab1',
            icon: 'bookmarks',
            label: 'Label Images',
        },
        {
            id: 'tab4',
            icon: 'join_inner',
            label: 'Output',
        },
    ]
    let activeTab = tabs[0];


    let drawChoises = ['Box', 'Circle'];
    let selectedDraw = 'Circle';
    let selectEntity;
    let resExtents = [];
    let resultMap;
    let selected = [];
    let settings = {};
    let labelSelection = null;
    
    onMount(() => {
        addInteraction();
    })
    const updateSettings = () => {
        settings = {...loadSettings()}
    }
    export function resetSettings(){
        removeSettings();
        updateSettings()
    }
    updateSettings();
    console.log(settings);
    if(!settings.version) resetSettings();

    const onChangeForeground = (view) => {
        updateSettings();
        settings.center = view.getCenter();
        settings.zoom = Math.round(view.getZoom());
        saveSettings(settings)
    }
    
    const addExtent = () => {
        console.log('addExtent');
        updateSettings();
        settings.background.extents = [...settings.background.extents, {
            id: nanoid(),
            center: settings.center,
            zoom: settings.zoom,
            extent: selectEntity.getExtentFromDimensions(settings.outputDimension)
        }];
        saveSettings(settings);
    }
    const getSelectedLabel = () => {
        updateSettings()
        return settings.selectedLabel;
    }
    const addDraw = (pixelExtent, extent, zoom, widthHeight) => {
        updateSettings();
        const selectedLabel = getSelectedLabel();
        

        const image = extractImageFromCanvas(document.querySelector('#select-entity canvas'), pixelExtent, selectedDraw);
        settings.foreground.extents = [{
            id: nanoid(),
            added: new Date().getTime,
            label: selectedLabel,
            image,
            pixelExtent,
            extent,
            zoom,
            type: selectedDraw,
            widthHeight
        }, ...settings.foreground.extents];

        saveSettings(settings)
    }
    const addInteraction = () => {
        if(selectEntity)
            selectEntity.addInteraction(selectedDraw)
    }
    const changeInteraction = (value) => {
        selectedDraw = value;
        addInteraction();
    }

    let renderResultComplete = () => {}
    
    let resultTemp = {
        center: null,
        zoom: null,
    }

    const isRendered = async(rendered, mapExtent, fileNameCount, resolve, reject) => {
        if(rendered){
            resolve(fileNameCount);
            return;
        }
        if(rendered){
            let canvas = await copyCanvas(document.querySelector('#result-map canvas'));

            settings = {...loadSettings()}
            const placesImages = await addEntitiesToExtent(canvas, mapExtent, settings.foreground.extents, settings);
            canvas = placesImages.canvas;

            resExtents = [{
                fileName: `image-zoom${mapExtent.zoom}-${fileNameCount}`,
                canvas: canvas,
                dataUrl: canvas.toDataURL("image/jpeg", 0.95),
                annotation: placesImages.annotation
            }, ...resExtents];
            resolve(resultMap);
        }else{
            reject('Render failed');
        }
    }
    const generateImage = async(mapExtent, fileNameCount) => {
        

        return new Promise((resolve, reject) => {
            if(resultTemp.center === mapExtent.center && resultTemp.zoom === mapExtent.zoom){

            }
            resultTemp.center = mapExtent.center;
            resultTemp.zoom = mapExtent.zoom;
            renderResultComplete = async(rendered) => {
                isRendered(rendered, mapExtent, fileNameCount, resolve, reject)
            }
            
        })
    }
    

    $: changeInteraction(selectedDraw)
    
    const removeForegroundExtend = (extent) => {
        updateSettings();
        settings.foreground.extents = settings.foreground.extents.filter(e => e.id !== extent.id);
        saveSettings(settings)
    }
    const removeBackgroundExtend = (extent) => {
        updateSettings();
        settings.background.extents = settings.background.extents.filter(e => e.id !== extent.id);
        saveSettings(settings)
    }
    const predict = async (e) => {
        
        const canvas = document.querySelector('#select-entity canvas');
        console.log(canvas);
        if(!canvas) return;
        const currentBbox = selectEntity.getBboxExt();
        
        predicting = true;
        getPredictionFromCanvas(canvas, currentBbox).then(res => selectEntity.addDetectedExt(res)).catch(err => console.log(err)).finally(() => {
            predicting = false;
        })
    }
    const showDrawer = (type) => {
        if(type === drawerType && openExtends){
            openExtends = false;
        }else{
            drawerType = type;
            openExtends = true;
        }
        
        selectEntity.redraw();
    }
    const hideDrawer = () => {
        drawerType = null;
        openExtends = false;
        selectEntity.redraw();
    }

    const getLabelName = (labelId) => {
        const found = settings.labels.filter((label) => label.labelId === labelId)
        return !found.length ? 'not defined' : found[0].name
    }

    const focusTo = (entity) => {
        console.log('focus To', entity);
        selectEntity.focus(entity.center, entity.zoom);
    }
    export function focusToLatLngExtent(extent){
        if(!extent) return;
        selectEntity.focusLatLngExtent(extent);
    }
    const focusToExtent = (entity) => {
        selectEntity.focusExtent(entity.extent, entity.zoom);
    }
    const checkDrawer = (tab) => {
        if(tab.id === 'tab1' && drawerType === 'settings'){
            drawerType = 'forground';
        }else if(tab.id === 'tab4' && drawerType !== 'settings'){
            drawerType = 'settings';
        }
    }
    const geoJsonLoaded = (fileName, geoJson) =>{
        console.log(fileName, geoJson, selectEntity);
        selectEntity.updateGeoJson(geoJson, fileName)
    }
    let selectedBasemap = {};
    const _onSelectBasemap = () => {
        let selected;

        updateSettings();
        selectedBasemap = settings.basemaps.find(basemap => basemap.selected === true);
        
        if(!selectedBasemap) {
            selectedBasemap = settings.basemaps[0];
        }
    }

    $: checkDrawer(activeTab)
</script>
<TabBar {tabs} let:tab bind:active={activeTab}>
    <Tab {tab}>
      <Icon class="material-icons">{tab.icon}</Icon>
      <Label>{tab.label}</Label>
    </Tab>
</TabBar>
<div class="ge-fill-height">
    <Drawer variant="modal" fixed={false} bind:open={openExtends}>
        <Content>
            <div class="ge-column h100">
                {#if drawerType === 'forground'}
                        <div class="ge-row">
                            <div class="mdc-typography--headline5 ge-margin">Object Extents</div>
                            <IconButton class="material-icons" on:click={hideDrawer}>chevron_left</IconButton>
                        </div>
                        <div class="mdc-typography--body2 ge-margin">Use the drawing options "Circle" or "Box" to label your objects on the map.</div>
                        <DataTable class="ge-scrollable ge-grow" stickyHeader table$aria-label="User list" style="width: 100%;">
                            <Head>
                                <Row>
                                    <TableCell>Preview</TableCell>
                                    <TableCell>Label</TableCell>
                                    <TableCell>Type</TableCell>
                                    <TableCell>Width [m]</TableCell>
                                    <TableCell>Height [m]</TableCell>
                                    <TableCell></TableCell>
                                </Row>
                            </Head>
                            <Body>
                                {#each settings.foreground.extents  as entity, i}
                                    <Row on:click={() => focusToExtent(entity)}>
                                        <TableCell><div class="ge-avatar" style="background-image: url({entity.image});"></div></TableCell>
                                        <TableCell>{getLabelName(entity.label)}</TableCell>
                                        <TableCell>{entity.type}</TableCell>
                                        <TableCell>{entity.widthHeight[0]}</TableCell>
                                        <TableCell>{entity.widthHeight[1]}</TableCell>
                                        <TableCell >
                                            <IconButton class="material-icons" on:click={() => removeForegroundExtend(entity)}>delete</IconButton>
                                        </TableCell>
                                    </Row>
                                {/each}
                            </Body>
                        </DataTable>
                {:else if drawerType === 'background'}
                    <div class="ge-row">
                        <div class="mdc-typography--headline5 ge-margin">Background Extents</div>
                        <IconButton class="material-icons" on:click={hideDrawer}>chevron_left</IconButton>
                    </div>
                    <div class="ge-row">
                        <div class="mdc-typography--body2 ge-margin">Display output image extent:</div>
                        <Switch bind:checked={settings.displayOutputDimension} />
                    </div>

                    <BaseMapSelection onSelectBasemap={_onSelectBasemap}/>

                    <!--<Fab color="primary" on:click={() => addExtent()} mini>
                        <Icon class="material-icons">add</Icon>
                    </Fab>-->
                    <DataTable class="ge-scrollable" stickyHeader table$aria-label="User list" style="width: 100%;">
                        <Head>
                            <Row>
                                <TableCell >Longitude</TableCell>
                                <TableCell >Latitude</TableCell>
                                <TableCell ></TableCell>
                            </Row>
                        </Head>
                        <Body>
                            {#each settings.background.extents as backgroundExtent}
                                <Row on:click={() => focusTo(backgroundExtent)}>
                                    <TableCell>{selectEntity.coordinatesToLatLong(backgroundExtent.center)[0]}</TableCell>
                                    <TableCell>{selectEntity.coordinatesToLatLong(backgroundExtent.center)[1]}</TableCell>
                                    <TableCell >
                                        <IconButton class="material-icons" on:click={() => removeBackgroundExtend(backgroundExtent)}>delete</IconButton>
                                    </TableCell>
                                </Row>
                            {/each}
                        </Body>
                    </DataTable>
                {:else if drawerType === 'settings'}
                    <div class="ge-row">
                        <div class="mdc-typography--headline5 ge-margin">Output Settings</div>
                        <IconButton class="material-icons" on:click={hideDrawer}>chevron_left</IconButton>
                    </div>
                    <div class="ge-scrollable ge-grow"  style="width: 100%;">
                        <OutputSettings projectUpdateSettings={updateSettings} projectSettings={settings}/>
                        <div class="mdc-typography--headline6 ge-margin">Syntatic</div>
                        <OutputSyntaticSettings projectUpdateSettings={updateSettings} projectSettings={settings}/>
                    </div> 
                {/if}
            </div>
        </Content>
    </Drawer>
<AppContent class="ge-output-wrapper h100 noselect">
{#if activeTab.id === 'tab1'}
        
            <!--<Button on:click={showDrawer}>
                {openExtends ? 'Close' : 'Open'}
            </Button>-->
        <DropGeoJson class="h100" geoJsonLoaded={geoJsonLoaded}>
            
            <div id="select-entity" class="h100">
                <svelte:component bind:this={selectEntity} this={OpenLayers} 
                center={settings.center} 
                zoom={settings.zoom}
                outputDimension={settings.outputDimension}
                displayOutputDimension={settings.displayOutputDimension}
                width="100%" height="100%" onChange={onChangeForeground} addDraw={addDraw}
                features={settings.foreground}
                backgroundFeatures={settings.background}
                basemap={selectedBasemap}
                ></svelte:component>
                <div class="ge-abs-mb">
                    <Button variant="raised" on:click={addExtent}>
                        <Icon class="material-icons">library_add</Icon>
                        <Label>Add Background Extent</Label>
                    </Button>
                    {#if selectEntity}
                        <br/><Button variant="raised" color="secondary">
                            <Icon class="material-icons">pin_drop</Icon>
                            <Label>
                                <small>
                                    Lon:&nbsp;{selectEntity.coordinatesToLatLong(settings.center)[0]}, 
                                    Lat:&nbsp;{selectEntity.coordinatesToLatLong(settings.center)[1]},
                                    Zoom:&nbsp;{settings.zoom}
                                </small>
                            </Label>
                        </Button>
                    {/if}
                </div>
            </div>
            
            <div class="ge-abs-ml">
                <div>
                    <Fab class="ge-drawer-btn" style="position: relative;" on:click={() => showDrawer('forground')} mini>
                        <Icon class="material-icons">nature</Icon>
                        <Badge aria-label="unread content count">{settings.foreground.extents.length}</Badge>
                    </Fab>
                </div>
                <br/>
                <div>
                    <Fab class="ge-drawer-btn" style="position: relative;" on:click={() => showDrawer('background')} mini>
                        <Icon class="material-icons">select_all</Icon>
                        <Badge aria-label="unread content count">{settings.background.extents.length}</Badge>
                    </Fab>
                </div>
            </div>
            <div class="ge-abs-tl">
               <LabelSelection bind:this={labelSelection} projectUpdateSettings={updateSettings} projectSettings={settings}/>
            </div>
            <div class="ge-abs-tr">
                <Set chips={drawChoises} let:chip choice bind:selected={selectedDraw} class="ge-noshrink">
                    <Chip {chip}>
                        <Text>{chip}</Text>
                    </Chip>
                </Set>
            </div>
           
        
    </DropGeoJson>
{:else if activeTab.id === 'tab4'}

        <RealDataList/>

        <SyntaticDataList/>
    
        <div class="ge-fixed-ml">
            <div>
                <Fab class="ge-drawer-btn" style="position: relative;" on:click={() => showDrawer('settings')} mini>
                    <Icon class="material-icons">settings</Icon>
                </Fab>
            </div>
        </div>
{/if}
</AppContent>
</div>
    
<style>
    hr{
        border: none;
        border-top: 1px solid rgba(150, 150, 150, .5);
        margin: 1em 0;
    }
    .ge-generation-preview{
        display: none;
    }
</style>